import React from 'react';
import {
    FormControl,
    FormLabel,
    Input,
    FormErrorMessage,
    Textarea,
} from '@chakra-ui/react';
import {Field} from 'formik';

const TextInput = ({label, name, type = "text", placeholder, errors, touched, textarea = false, ...props}) => (
    <FormControl isInvalid={errors[name] && touched[name]}>
        <FormLabel color={'textPrimary'} fontFamily={'Poppins'} fontWeight={'400'} fontSize={'16px'} lineHeight={'150%'} mb={0} pb={1} htmlFor={name}>
            {label}
        </FormLabel>
            <Field
                as={textarea ? Textarea : Input}
                id={name}
                name={name}
                type={type}
                placeholder={placeholder}
                _placeholder={{color: 'gray4'}}
                bg="white"
                backgroundColor="white"
                variant="outline"
                borderRadius={0}
                border="1px"
                borderColor="#9D9D9D"
                fontSize={{base: 'sm', sm: 'md'}}
                {...props}
            />
        <FormErrorMessage>{errors[name]}</FormErrorMessage>
    </FormControl>
);

export default TextInput;
